import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const haveInstance = (state, instance) => state.some((item) => item.treatmentProgramId === instance.treatmentProgramId);

export const treatmentProgramsSlice = createSlice({
  name: 'treatmentPrograms',
  initialState: initialState,
  reducers: {
    clearTreatmentPrograms: () => {
      return initialState;
    },

    addTreatmentProgram: (state, action) => {
      const instance = action.payload;
      return haveInstance(state, instance) ? state : [...state, instance];
    },
  },
});

export const { clearTreatmentPrograms, addTreatmentProgram } = treatmentProgramsSlice.actions;

export default treatmentProgramsSlice.reducer;
